/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";

export interface IDropDownItemProps {
    name: string;
    link?: string;
    ddItems?: {
        name: string;
        link: string;
    }[];
}

export interface INavItemProps {
    type: "drop-down" | "link" | "button";
    name: string;
    link?: string;
    active?: boolean;
    dropDownItems?: IDropDownItemProps[];
}

export interface IHeaderCompProps {
    headerSectionId?: string;
    headerLogo?: string;
    headerLink?: string;
    headerTitle?: string;
    headerTitleStyle?: string;
    navItems?: INavItemProps[];
}

export const HeaderComp = ({
    headerSectionId,
    headerLogo,
    headerLink,
    headerTitle,
    headerTitleStyle,
    navItems
}: IHeaderCompProps) => {
    const _renderHeaderLogo = () => {
        if (headerLogo) {
            return (
                <a href={headerLink} className="logo d-flex align-items-center">
                    <img src={headerLogo} alt="" />
                    {headerTitle && (
                        <span style={headerTitleStyle}>{headerTitle}</span>
                    )}
                </a>
            );
        }
    };

    const _renderDeepDropDownItemsIf = (item?: any) => {
        let _comp: any = [];
        item?.map((_item: any, index: number) => {
            if (_item?.name && _item?.link) {
                _comp.push(
                    <li key={`landing-page-header-nav-dd-item-c-${index}`}>
                        <a href={_item?.link}>{_item?.name}</a>
                    </li>
                );
            }
        });
        return _comp;
    };

    const _renderDropDownItems = (dd?: IDropDownItemProps[]) => {
        let _comp: any = [];
        dd?.map((_item, index) => {
            if (_item?.ddItems) {
                _comp.push(
                    <li
                        className="dropdown"
                        key={`landing-page-header-nav-dd-items-p-${index}`}
                    >
                        <a href={_item?.link ?? "#"}>
                            <span>{_item?.name}</span>
                            <i className="bi bi-chevron-right" />
                        </a>
                        <ul>{_renderDeepDropDownItemsIf(_item?.ddItems)}</ul>
                    </li>
                );
            } else {
                _comp.push(
                    <li key={`landing-page-header-nav-dd-item-p-${index}`}>
                        <a href={_item?.link}>{_item?.name}</a>
                    </li>
                );
            }
        });
        return _comp;
    };

    const _renderNavigation = () => {
        return (
            <nav id="navbar" className="navbar">
                <ul>
                    {navItems?.map((navItem, index) => {
                        if (
                            navItem?.type === "link" &&
                            navItem?.link &&
                            navItem?.name
                        ) {
                            let _linkClassName = `nav-link scrollto`;
                            if (navItem?.active) {
                                _linkClassName = `${_linkClassName} active`;
                            }
                            return (
                                <li key={`landing-page-header-navbar-${index}`}>
                                    <a
                                        className={_linkClassName}
                                        href={navItem?.link}
                                    >
                                        {navItem?.name?.trim()}
                                    </a>
                                </li>
                            );
                        }
                        if (navItem?.type === "drop-down") {
                            return (
                                <li
                                    className="dropdown"
                                    key={`landing-page-header-navbar-${index}`}
                                >
                                    <a href={navItem?.link ?? "#"}>
                                        <span>{navItem?.name}</span>
                                        <i className="bi bi-chevron-down" />
                                    </a>
                                    <ul>
                                        {_renderDropDownItems(
                                            navItem?.dropDownItems
                                        )}
                                    </ul>
                                </li>
                            );
                        }
                        if (
                            navItem?.type === "button" &&
                            navItem?.link &&
                            navItem?.name
                        ) {
                            return (
                                <li key={`landing-page-header-navbar-${index}`}>
                                    <a
                                        className="getstarted scrollto"
                                        href={navItem?.link}
                                    >
                                        {navItem?.name}
                                    </a>
                                </li>
                            );
                        }
                    })}
                </ul>
                <i className="bi bi-list mobile-nav-toggle" />
            </nav>
        );
    };

    return (
        <header id={headerSectionId} className="header fixed-top">
            <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
                {_renderHeaderLogo()}
                {_renderNavigation()}
            </div>
        </header>
    );
};

HeaderComp.defaultProps = {
    headerSectionId: "header",
    headerLink: "/"
};
